/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { CorrespondenceRequest } from '../models';
import { CorrespondenceViewIEnumerableResponse } from '../models';
import { CorrespondenceViewResponse } from '../models';
import { FileView } from '../models';
/**
 * CorrespondenceApi - axios parameter creator
 * @export
 */
export const CorrespondenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA Admin | Delete Correspondence
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete: async (correspondenceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'correspondenceId' is not null or undefined
            if (correspondenceId === null || correspondenceId === undefined) {
                throw new RequiredError('correspondenceId','Required parameter correspondenceId was null or undefined when calling apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete.');
            }
            const localVarPath = `/api/v2/Correspondence/DeleteCorrespondence/{correspondenceId}`
                .replace(`{${"correspondenceId"}}`, encodeURIComponent(String(correspondenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondence By Id
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet: async (correspondenceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'correspondenceId' is not null or undefined
            if (correspondenceId === null || correspondenceId === undefined) {
                throw new RequiredError('correspondenceId','Required parameter correspondenceId was null or undefined when calling apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet.');
            }
            const localVarPath = `/api/v2/Correspondence/GetCorrespondenceById/{correspondenceId}`
                .replace(`{${"correspondenceId"}}`, encodeURIComponent(String(correspondenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondences By PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Correspondence/GetCorrespondenceByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Correspondence File
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet: async (correspondenceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'correspondenceId' is not null or undefined
            if (correspondenceId === null || correspondenceId === undefined) {
                throw new RequiredError('correspondenceId','Required parameter correspondenceId was null or undefined when calling apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet.');
            }
            const localVarPath = `/api/v2/Correspondence/GetFileByCorrespondenceId/{correspondenceId}`
                .replace(`{${"correspondenceId"}}`, encodeURIComponent(String(correspondenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondence File Stream
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet: async (correspondenceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'correspondenceId' is not null or undefined
            if (correspondenceId === null || correspondenceId === undefined) {
                throw new RequiredError('correspondenceId','Required parameter correspondenceId was null or undefined when calling apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet.');
            }
            const localVarPath = `/api/v2/Correspondence/GetFileStreamByCorrespondenceId/{correspondenceId}`
                .replace(`{${"correspondenceId"}}`, encodeURIComponent(String(correspondenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Save Correspondence
         * @param {CorrespondenceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceSaveCorrespondencePost: async (body?: CorrespondenceRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Correspondence/SaveCorrespondence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorrespondenceApi - functional programming interface
 * @export
 */
export const CorrespondenceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA Admin | Delete Correspondence
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete(correspondenceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete(correspondenceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondence By Id
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet(correspondenceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorrespondenceViewResponse>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet(correspondenceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondences By PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorrespondenceViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Correspondence File
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileView>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondence File Stream
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Save Correspondence
         * @param {CorrespondenceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CorrespondenceSaveCorrespondencePost(body?: CorrespondenceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV2CorrespondenceSaveCorrespondencePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CorrespondenceApi - factory interface
 * @export
 */
export const CorrespondenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA Admin | Delete Correspondence
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete(correspondenceId: number, options?: any): AxiosPromise<BooleanResponse> {
            return CorrespondenceApiFp(configuration).apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete(correspondenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondence By Id
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet(correspondenceId: number, options?: any): AxiosPromise<CorrespondenceViewResponse> {
            return CorrespondenceApiFp(configuration).apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondences By PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<CorrespondenceViewIEnumerableResponse> {
            return CorrespondenceApiFp(configuration).apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Correspondence File
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any): AxiosPromise<FileView> {
            return CorrespondenceApiFp(configuration).apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Returns Correspondence File Stream
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any): AxiosPromise<string> {
            return CorrespondenceApiFp(configuration).apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Save Correspondence
         * @param {CorrespondenceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CorrespondenceSaveCorrespondencePost(body?: CorrespondenceRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CorrespondenceApiFp(configuration).apiV2CorrespondenceSaveCorrespondencePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CorrespondenceApi - object-oriented interface
 * @export
 * @class CorrespondenceApi
 * @extends {BaseAPI}
 */
export class CorrespondenceApi extends BaseAPI {
    /**
     * 
     * @summary TA Admin | Delete Correspondence
     * @param {number} correspondenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete(correspondenceId: number, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV2CorrespondenceDeleteCorrespondenceCorrespondenceIdDelete(correspondenceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Returns Correspondence By Id
     * @param {number} correspondenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet(correspondenceId: number, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV2CorrespondenceGetCorrespondenceByIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Returns Correspondences By PracticeId
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV2CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Correspondence File
     * @param {number} correspondenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV2CorrespondenceGetFileByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Returns Correspondence File Stream
     * @param {number} correspondenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV2CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Save Correspondence
     * @param {CorrespondenceRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV2CorrespondenceSaveCorrespondencePost(body?: CorrespondenceRequest, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV2CorrespondenceSaveCorrespondencePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
